import React from 'react';

export default function Component(props) {

const { question, answersList, ansTextBoxChange1, surveyScreenData, themeObj } = props;

return(
    <>
      {/* <input 
        type="date"
        value={(answersList && answersList.length > 0 && answersList
          .findIndex(item => item.questionId === question.id) !== -1) ?
          answersList[answersList.findIndex(item => item.questionId === question.id)].answer1
          : ''} 
        onChange={(event)=>ansTextBoxChange1(event,question)} 
        className="w-full bg-gray-100 rounded-md mt-4 p-3 text-sm  placeholder-gray-500" 
        placeholder={"Date.."}  /> */}



            <div className="py-6  lg:text-base text-sm font-normal  mb-4 gap-3 mr-auto lg:w-11/12">
              <div className="w-full">
                <input 
                type="date"
                value={(answersList && answersList.length > 0 && answersList
                  .findIndex(item => item.questionId === question.id) !== -1) ?
                  answersList[answersList.findIndex(item => item.questionId === question.id)].answer1
                  : ''}
                onChange={(event)=>ansTextBoxChange1(event,question)} 
                style={{borderBottomColor:themeObj["borderColor"]}}
                className={"p-2 bg-transparent focus:outline-none border-b  text-white placeholder-["+themeObj["textColor"]+"] text-lg w-full border-opacity-50 focus:border-opacity-100 focus:border-b-2"} 
                placeholder={"Date.."}
                /></div>
            </div>



    </>
  );}